import React from 'react'

interface ApplicationContextProps {
  applications: Array<any>
  setApplications: (data: Array<any>) => void
  loadingApps: boolean
  setLoadingApps: (isLoading: boolean) => void
  searchValue: string
  setSearchValue: (val: string) => void
}

export const ApplicationContext = React.createContext<ApplicationContextProps>({
  applications: [],
  setApplications: () => {},
  loadingApps: false,
  setLoadingApps: () => {},
  searchValue: '',
  setSearchValue: () => {}
})
